import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    let zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    let expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
    document.cookie = 'time_zone=' + zone + ';' + expires + "; path=/";
  }
}